import { Button, Form, Modal } from 'antd';
import { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';

import style from './AddNotification.module.css';

import { ResultAddNotification } from '../../../../Enums/ResultAddNotification';

import {
  PlusCircleOutlined,
  TableOutlined,
  PartitionOutlined,
  PlusSquareOutlined,
  DeleteOutlined,
} from '@ant-design/icons';

export function AddNotification(props: {
  open: boolean;
  onCancel: Function;
  onChoose: Function;
}) {
  const [form] = Form.useForm();

  const { i18n, t } = useTranslation();

  const handleCancel = () => {
    props.onCancel();
  };

  const ChooseFunction = (result: ResultAddNotification) => {
    props.onChoose(result);
  };

  return (
    <Modal
      title={t('addNotification')}
      open={props.open}
      onOk={() => form.submit()}
      onCancel={handleCancel}
      footer={[
        <Button key="back" onClick={handleCancel}>
          {t('cancel')}
        </Button>,
      ]}
    >
      <div className={style.buttonRow}>
        <Button
          icon={<PlusCircleOutlined />}
          type="primary"
          onClick={() => ChooseFunction(ResultAddNotification.AddSensorBoolean)}
        >
          {t('addSensorBoolean')}
        </Button>
        <Button
          icon={<PlusCircleOutlined />}
          type="primary"
          onClick={() => ChooseFunction(ResultAddNotification.AddSensorNumber)}
        >
          {t('addSensorNumber')}
        </Button>
        <Button
          disabled={true}
          type="primary"
          onClick={() => ChooseFunction(ResultAddNotification.AddSensorString)}
        >
          {t('addSensorString')}
        </Button>
      </div>
    </Modal>
  );
}
